(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hsn-related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('related-products-premium')) return;

    var WISHLIST_KEY = 'rpp:wishlist';
    var reduceMotion = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };
    var root = function () { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; };

    var readWishlist = function () {
      try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
    };
    var writeWishlist = function (list) {
      try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
    };

    class RelatedProductsPremium extends HTMLElement {
      connectedCallback() {
        if (this._loading || this._ready) return;
        if (this.dataset.url && this.dataset.loaded !== 'true') {
          this._loading = true;
          this.load();
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        if (this.revealObserver) this.revealObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      async load() {
        try {
          var res = await fetch(this.dataset.url);
          if (!res.ok) throw new Error(res.status);
          var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          var fresh = doc.querySelector('related-products-premium');
          var hasCards = fresh && fresh.querySelector('.fn-co__card');
          if (!hasCards && this.dataset.hideEmpty === 'true') return this.hideSection();
          this.innerHTML = fresh ? fresh.innerHTML : '';
          this.dataset.loaded = 'true';
          this.init();
        } catch (err) {
          this.hideSection();
        }
      }

      hideSection() {
        var wrapper = this.closest('.shopify-section') || this.closest('.rpp');
        if (wrapper) wrapper.style.display = 'none';
      }

      init() {
        if (this._ready) return;
        this._ready = true;
        this.track = this.querySelector('[data-rpp-track]');
        this.status = this.querySelector('[data-rpp-status]');
        this.setupSlider();
        this.setupReveal();
      }

      /* ---------- Section slider ---------- */
      setupSlider() {
        var track = this.track;
        if (!track || this.dataset.layout !== 'slider') return;
        var prevs = this.querySelectorAll('[data-rpp-prev]');
        var nexts = this.querySelectorAll('[data-rpp-next]');
        var bar = this.querySelector('[data-rpp-progress]');
        var rtl = getComputedStyle(track).direction === 'rtl';

        var step = function () {
          var item = track.querySelector('.rpp__item');
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          return item ? item.getBoundingClientRect().width + gap : track.clientWidth;
        };
        var update;
        var move = function (dir) {
          track.scrollBy({ left: dir * step() * (rtl ? -1 : 1), behavior: reduceMotion() ? 'auto' : 'smooth' });
          setTimeout(function () { update(); }, 480);
        };
        prevs.forEach(function (b) { b.addEventListener('click', function () { move(-1); }); });
        nexts.forEach(function (b) { b.addEventListener('click', function () { move(1); }); });

        var self = this;
        var raf;
        update = function () {
          var max = track.scrollWidth - track.clientWidth;
          var pos = Math.abs(track.scrollLeft);
          self.classList.toggle('is-static', max <= 2);
          prevs.forEach(function (b) { b.disabled = pos <= 2; });
          nexts.forEach(function (b) { b.disabled = pos >= max - 2; });
          if (bar && track.scrollWidth > 0) {
            var ratio = Math.min(1, track.clientWidth / track.scrollWidth);
            bar.style.width = (ratio * 100) + '%';
            bar.style.transform = 'translateX(' + ((pos / track.clientWidth) * 100) + '%)';
          }
        };
        track.addEventListener('scroll', function () {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(update);
        }, { passive: true });
        track.addEventListener('scrollend', function () { update(); }, { passive: true });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(update);
          this.resizeObserver.observe(track);
        }
        update();
      }

      /* ---------- Per-card image galleries ---------- */
/* ---------- Wishlist (localStorage, fires 'wishlist:updated') ---------- */
/* ---------- Add to cart ---------- */
async addToCart(e, btn) {
        e.preventDefault();
        if (btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        btn.classList.add('is-loading');

        var after = this.dataset.afterAdd;
        var variantId = Number(btn.dataset.variantId);

        try {
          var res = await fetch(root() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
          var data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || btn.dataset.errorLabel);

          /* Theme cart: counters and drawer re-render on cart:refresh. */
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (after === 'cart') {
            window.location.href = root() + 'cart';
            return;
          }
          if (after === 'drawer') {
            var drawer = document.getElementById('cart-drawer');
            if (drawer && typeof drawer.show === 'function') drawer.show();
            else {
              window.location.href = root() + 'cart';
              return;
            }
          }
          this.flash(btn, btn.dataset.addedLabel, false);
        } catch (err) {
          this.flash(btn, err.message || btn.dataset.errorLabel, true);
        } finally {
          btn.removeAttribute('aria-busy');
          btn.classList.remove('is-loading');
        }
      }

/* ---------- Scroll reveal (fires once) ---------- */
      setupReveal() {
        var items = this.querySelectorAll('[data-rpp-item]');
        var designMode = window.Shopify && window.Shopify.designMode;
        if (this.dataset.reveal !== 'true' || designMode || reduceMotion() || !('IntersectionObserver' in window) || !items.length) return;
        this.classList.add('is-reveal-ready');
        this.revealObserver = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
        items.forEach(function (item) { this.revealObserver.observe(item); }, this);
      }
    }

    customElements.define('related-products-premium', RelatedProductsPremium);
  })();

  } catch(e) { console.error(e); }
})();
})();
